import { Action } from "@ngrx/store";
import { Ranking } from "src/app/shared/interfaces/ranking";
import { RankingScope } from "src/app/shared/interfaces/ranking-scope";
import { RankingCriteria } from "src/app/shared/models/ranking-criteria";
import { Guid } from "src/app/shared/types/guid";

export const GET_RANKING = "[Ranking Method] GetRanking";
export const GET_RANKING_COMPLETED = "[Ranking Method] GetRankingCompleted";
export const GET_RANKING_FAILED = "[Ranking Method] GetRankingFailed";
export const REFRESH_RANKING = "[Ranking Method] RefreshRanking";
export const REFRESH_RANKING_FAILED = "[Ranking Method] RefreshRankingFailed";
export const RANKING_CHANGED = "[Ranking Method] RankingChanged";

export const GET_RANKING_SCOPES = "[Ranking Method] GetRankingScopes";
export const GET_RANKING_SCOPES_COMPLETED =
  "[Ranking Method] GetRankingScopesCompleted";
export const GET_RANKING_SCOPES_FAILED =
  "[Ranking Method] GetRankingScopesFailed";

export const UPDATE_RANKING_CRITERIA = "[Ranking Method] UpdateRankingCriteria";

export class GetRanking implements Action {
  readonly type = GET_RANKING;

  constructor(public payload: RankingCriteria) {}
}

export class GetRankingCompleted implements Action {
  readonly type = GET_RANKING_COMPLETED;

  constructor(public payload: Ranking) {}
}

export class GetRankingFailed implements Action {
  readonly type = GET_RANKING_FAILED;

  constructor(
    public payload: { error: boolean; unavailable?: boolean } = {
      error: false,
    },
  ) {}
}

export class RefreshRanking implements Action {
  readonly type = REFRESH_RANKING;

  constructor(
    public payload: RankingCriteria,
    public manual: boolean = false,
  ) {}
}

export class RefreshRankingFailed implements Action {
  readonly type = REFRESH_RANKING_FAILED;
}

export class RankingChanged implements Action {
  readonly type = RANKING_CHANGED;

  constructor(public payload: { group_id: Guid }) {}
}

export class GetRankingScopes implements Action {
  readonly type = GET_RANKING_SCOPES;
}

export class GetRankingScopesCompleted implements Action {
  readonly type = GET_RANKING_SCOPES_COMPLETED;

  constructor(public payload: Array<RankingScope>) {}
}

export class GetRankingScopesFailed implements Action {
  readonly type = GET_RANKING_SCOPES_FAILED;
}

export class UpdateRankingCriteria implements Action {
  readonly type = UPDATE_RANKING_CRITERIA;

  constructor(public payload: RankingCriteria) {}
}

export type RankingActions =
  | GetRanking
  | GetRankingCompleted
  | GetRankingFailed
  | RefreshRanking
  | RefreshRankingFailed
  | RankingChanged
  | GetRankingScopes
  | GetRankingScopesCompleted
  | GetRankingScopesFailed
  | UpdateRankingCriteria;
